import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import { CartProvider } from "@/lib/cart";
import { CartDrawer } from "@/components/CartDrawer";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import AllProducts from "@/pages/AllProducts";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import TradeAccount from "@/pages/TradeAccount";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

// Strip any "Made with Emergent" branding that might be injected by external scripts.
const useStripEmergentBadge = () => {
  useEffect(() => {
    const clean = () => {
      document.querySelectorAll(
        '[id*="emergent" i],[class*="emergent" i],a[href*="emergent.sh" i],a[href*="app.emergent" i]'
      ).forEach((el) => {
        const txt = (el.textContent || "").toLowerCase();
        if (txt.includes("emergent") || (el.tagName === "A" && (el.href || "").includes("emergent"))) {
          el.remove();
        }
      });
    };
    clean();
    const obs = new MutationObserver(clean);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
};

function App() {
  useLenis();
  useStripEmergentBadge();
  return (
    <HelmetProvider>
      <div className="App bg-vr-bg min-h-screen">
        <CartProvider>
          <BrowserRouter>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<AllProducts />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/trade-account" element={<TradeAccount />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/industries/:slug" element={<IndustryDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
          </BrowserRouter>
          <CartDrawer />
        </CartProvider>
        <Toaster position="bottom-right" theme="light" toastOptions={{ style: { background: "#ffffff", border: "1px solid #e2e8ea", color: "#15242f" } }} />
      </div>
    </HelmetProvider>
  );
}

export default App;
